module.exports = __webpack_public_path__ + "img/sift-23.58684ffe.jpg";